import { DropdownSearchBar as GammaDropdownSearchBar } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type DropdownSearchBarProps = React.ComponentProps<typeof GammaDropdownSearchBar>

type Props = Omit<DropdownSearchBarProps, 'selectValue' | 'missingLabel'> & {
  missingLabel?: string
}

const DropdownSearchBar: React.FC<Props> = ({ missingLabel, ...props }) => (
  <GammaDropdownSearchBar
    {...props}
    missingLabel={missingLabel ?? i18n.t('common.missing_field')}
    selectValue={i18n.t('common.select')}
  />
)

export default DropdownSearchBar
